const state = {
  // 人员
  searchPerApproval: null,
  searchPerAppliceApproval: null,
  searchPerFinalApproval: null,
  searchPerAppliceHistory: null,
  searchAllPerAppliceHistory: null,
  // 保存人员预约历史表格数据
  allPerAppliceHistoryTableData: null,
  allPerAppliceHistoryPagination: null,
  // 保存车辆预约历史表格数据
  allCarAppliceHistoryTableData: null,
  allCarAppliceHistoryPagination: null,
  // 保存车辆备案历史表格数据
  carRegHistoryTableData: null,
  carRegHistoryPagination: null,
  // 车辆
  searchCarEnterApplice: null,
  searchCarAppliceApproval: null,
  searchCarAppliceHistory: null,
  searchCarHazardousApproval: null,
  searchCarHeavytipperApproval: null,
  searchCarMediumlargeApproval: null,
  searchShddfinalApproval: null,
  searchAllCarAppliceHistory: null,
  searchCarRegistration: null,
  searchCarRegApproval: null,
  searchCarRegHistory: null,
  searchCarMark: null,
  // 设备管理
  searchEquipCarFace: null,
  searchEquipSecurity: null,
  searchEquipCarScale: null,
  searchEquipGate: null,
  searchEquipBuried: null,
  searchEquipBumping: null,
  // 黑白名单
  searchBlackCar: null,
  searchBlackCarApproval: null,
  searchBlackPerson: null,
  searchBlackPersonApproval: null,
  // 过闸记录
  searchGateVehicle: null,
  searchGatePerson: null,
  // 系统报表
  personReservation: null,
  personCount: null,
  vehicleReservation: null,
  vehicleCount: null,
  vehicleGate: null,
  vehicleIncrease: null,
  searchCarApplicationApprovalRecord: null,
  searchVehicleRegistrationApprovalRecord: null,
  searchPersonApplicationApprovalRecord: null,
}

const mutations = {
  setPerApproval(state, params) {
    state.searchPerApproval = params
  },
  setPerAppliceApproval(state, params) {
    state.searchPerAppliceApproval = params
  },
  setPerFinalApproval(state, params) {
    state.searchPerFinalApproval = params
  },
  setPerAppliceHistory(state, params) {
    state.searchPerAppliceHistory = params
  },
  setAllPerAppliceHistory(state, params) {
    state.searchAllPerAppliceHistory = params
  },
  // 保存人员预约历史表格数据
  setAllPerAppliceHistoryTableData(state, data) {
    state.allPerAppliceHistoryTableData = data
  },
  setAllPerAppliceHistoryPagination(state, pagination) {
    state.allPerAppliceHistoryPagination = pagination
  },
  // 保存车辆预约历史表格数据
  setAllCarAppliceHistoryTableData(state, data) {
    state.allCarAppliceHistoryTableData = data
  },
  setAllCarAppliceHistoryPagination(state, pagination) {
    state.allCarAppliceHistoryPagination = pagination
  },
  // 保存车辆备案历史表格数据
  setCarRegHistoryTableData(state, data) {
    state.carRegHistoryTableData = data
  },
  setCarRegHistoryPagination(state, pagination) {
    state.carRegHistoryPagination = pagination
  },
  setCarEnterApplice(state, params) {
    state.searchCarEnterApplice = params
  },
  setCarAppliceApproval(state, params) {
    state.searchCarAppliceApproval = params
  },
  setCarAppliceHistory(state, params) {
    state.searchCarAppliceHistory = params
  },
  setSearchCarHazardousApproval(state, params) {
    state.searchCarHazardousApproval = params
  },
  setSearchCarHeavytipperApproval(state, params) {
    state.searchCarHeavytipperApproval = params
  },
  setSearchCarMediumlargeApproval(state, params) {
    state.searchCarMediumlargeApproval = params
  },
  setSearchShddfinalApproval(state, params) {
    state.searchShddfinalApproval = params
  },
  setAllCarAppliceHistory(state, params) {
    state.searchAllCarAppliceHistory = params
  },
  setCarRegistration(state, params) {
    state.searchCarRegistration = params
  },
  setCarRegApproval(state, params) {
    state.searchCarRegApproval = params
  },
  setCarRegHistory(state, params) {
    state.searchCarRegHistory = params
  },
  setCarMark(state, params) {
    state.searchCarMark = params
  },
  setEquipCarFace(state, params) {
    state.searchEquipCarFace = params
  },
  setEquipSecurity(state, params) {
    state.searchEquipSecurity = params
  },
  setEquipCarScale(state, params) {
    state.searchEquipCarScale = params
  },
  setEquipGate(state, params) {
    state.searchEquipGate = params
  },
  setEquipBuried(state, params) {
    state.searchEquipBuried = params
  },
  setEquipBumping(state, params) {
    state.searchEquipBumping = params
  },
  setBlackCar(state, params) {
    state.searchBlackCar = params
  },
  setBlackCarApproval(state, params) {
    state.searchBlackCarApproval = params
  },
  setBlackPerson(state, params) {
    state.searchBlackPerson = params
  },
  setBlackPersonApproval(state, params) {
    state.searchBlackPersonApproval = params  
  },
  setGateVehicle(state, params) {
    state.searchGateVehicle = params
  },
  setGatePerson(state, params) {
    state.searchGatePerson = params
  },
  setPersonReservation(state, params) {
    state.personReservation = params
  },
  setPersonCount(state, params) {
    state.personCount = params
  },
  setVehicleReservation(state, params) {
    state.vehicleReservation = params
  },
  setVehicleCount(state, params) {
    state.vehicleCount = params
  },
  setVehicleGate(state, params) {
    state.vehicleGate = params
  },
  setVehicleIncrease(state, params) {
    state.vehicleIncrease = params
  },
  setCarApplicationApprovalApprovalRecord(state, params) {
    state.searchCarApplicationApprovalRecord = params
  },
  setVehicleRegistrationApprovalRecord(state, params) {
    state.searchVehicleRegistrationApprovalRecord = params
  },
  setPersonApplicationApprovalRecord(state, params) {
    state.searchPersonApplicationApprovalRecord = params
  },
}

export default {
  namespaced: true,
  state,
  mutations
}